import React from "react";
import { LoginStep2FormStyled } from "./styled";
import { useForm, Controller } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { useTranslation } from "react-i18next";
import { Inputs, Buttons } from "components";

const LoginStep2Form = ({ defaultEmail, onForgetPassword, onSubmit }) => {
  const schema = yup.object().shape({
    username: yup.string().required("*Required"),
    password: yup.string().required("*Required"),
  });

  const {
    control,
    handleSubmit,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(schema),
    defaultValues: {
      username: defaultEmail || "",
      password: "",
    },
  });

  const { t } = useTranslation(["common", "form"]);

  return (
    <LoginStep2FormStyled>
      <div className="login_header">{t("Log in", { ns: "common" })}</div>
      <form onSubmit={handleSubmit(onSubmit)}>
        <div className="input_wrap">
          <Controller
            control={control}
            render={({ field }) => (
              <Inputs.TextField
                {...field}
                placeholder={t("Enter your Email", { ns: "form" })}
                errors={errors.username?.message}
                disabled={!!defaultEmail}
              />
            )}
            name="username"
          />
        </div>
        <div className="input_wrap">
          <Controller
            control={control}
            render={({ field }) => (
              <Inputs.Password
                {...field}
                placeholder={t("Enter your Password", { ns: "form" })}
                errors={errors.password?.message}
              />
            )}
            name="password"
          />
        </div>
        <div className="btn_wrap">
          <Buttons.BgStandard
            type="submit"
            label={t("Continue", { ns: "common" })}
          />
        </div>
        <button
          type="button"
          className="btn_forget_passwoed"
          onClick={onForgetPassword}
        >
          {t("Forgot your password?", { ns: "form" })}
        </button>
      </form>
    </LoginStep2FormStyled>
  );
};

LoginStep2Form.propTypes = {};
export default LoginStep2Form;
